import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import * as NotificationsActions from "notifications/store/notification.reducer";

import ConfirmationDialog from "components/Dialogs/ConfirmationDialog";

import { markAsViewed, notificationsViewSet, openedNotificationSet } from "slices/notificationsSlice";
import { useAppDispatch } from "store";
import { HighlightedText } from "./styles";

const AssignmentConfirmed = ({ notify }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { data: { projectId, userFullName, projectName } } = notify;

  const handleClose = () => {
    dispatch(openedNotificationSet(null));
  };

  const closeNotificationList = () => {
    dispatch(notificationsViewSet(""));
  };

  const redirectToProject = () => {
    handleClose();
    closeNotificationList();
    dispatch(markAsViewed(notify.id));
    navigate(`/projects/${projectId}/details`);
  };

  return (
    <ConfirmationDialog
      open
      borderedTitle
      projectName={projectName}
      title="Assignment Confirmed"
      cancelButtonTitle="Close"
      confirmButtonTitle="Go to Project"
      onClose={handleClose}
      onCancel={handleClose}
      onConfirm={redirectToProject}
    >
      <HighlightedText>{userFullName}</HighlightedText>
      {" "}
      has confirmed the assignment for
      {" "}
      <HighlightedText>{projectName}</HighlightedText>
      {" "}
      project. You’ll be notified on further project activity.
    </ConfirmationDialog>
  );
};

export default AssignmentConfirmed;
